// Product navigation only. Opening/closing, focus and scroll locking use the
// existing theme modal-opener / modal-dialog; no variant or cart writes here.
if (!customElements.get('fabric-finished-products')) {
  customElements.define('fabric-finished-products', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.root = this.closest('fabric-yardage, .product__info-container');
      this.querySelector('[data-finished-opener]')?.addEventListener('click', event => {
        const template = this.querySelector('[data-finished-modal]');
        if (template) {
          if (!this.modal?.isConnected) {
            this.modal = template.content.firstElementChild.cloneNode(true);
            document.body.append(this.modal);
          }
          event.currentTarget.setAttribute('aria-controls', this.modal.id);
          this.modal.show(event.currentTarget);
        }
        this.updateLinks();
        // BCPO may also listen on the color heading; opening products must not
        // collapse or change the color selector underneath it.
        event.stopPropagation();
      });
      if (this.dataset.kind === 'swatch' && this.root) {
        // BCPO renders asynchronously and can replace its option wrappers.
        // Keep the same opener (and theme modal contract), beside Color.
        this.colorRowObserver = new MutationObserver(() => this.mountColorRow());
        this.colorRowObserver.observe(this.root, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-label'] });
        this.mountColorRow();
      }
    }
    disconnectedCallback() {
      // Only collection cards own a lazily mounted modal. PDP/BCPO openers can
      // move within their page and keep using the existing theme lifecycle.
      if (!this.modal) return;
      if (this.modal.hasAttribute('open')) this.modal.hide();
      this.modal.remove();
      this.modal = null;
    }
    mountColorRow() {
      const groups = [...this.root.querySelectorAll('#bcpo .single-option-selector')];
      const colorGroup = groups.find(group => /colou?r/i.test(group.getAttribute('aria-label') || ''));
      const row = colorGroup?.closest('.selector-wrapper')?.querySelector('.bcpo-label');
      if (!row) return;
      row.classList.add('fabric-products-color-row');
      if (this.parentElement !== row) row.append(this);
    }
    currentColor() {
      const native = this.root?.querySelector('[data-fabric-color]');
      if (native) return native.selectedOptions[0]?.dataset.colorName || native.selectedOptions[0]?.textContent.trim() || '';
      const groups = [...(this.root?.querySelectorAll('#bcpo .single-option-selector') || [])];
      const colorGroup = groups.find(group => /colou?r/i.test(group.getAttribute('aria-label') || ''));
      const selected = colorGroup?.querySelector('input:checked') || (colorGroup?.matches('select') ? colorGroup : null);
      if (selected) return selected.value;
      return this.root?.querySelector('variant-radios input[name*="color" i]:checked, variant-selects select[name*="color" i]')?.value || '';
    }
    updateLinks() {
      const modal = document.getElementById(this.dataset.modalId);
      if (!modal) return;
      const key = this.currentColor().toLowerCase().replace(/[ \-_/.,&'()+]/g, '').replace(/gray/g, 'grey');
      modal.querySelectorAll('[data-finished-card]').forEach(card => {
        const link = card.querySelector('[data-finished-link]');
        const label = card.querySelector('[data-finished-color]');
        const image = card.querySelector('img.fabric-products-card__image');
        // Reset first: an unmatched color must not retain a previous preselection or photo.
        link.setAttribute('href', card.dataset.productUrl);
        label.hidden = true;
        label.textContent = '';
        if (image) {
          if (!('defaultSrc' in image.dataset)) {
            image.dataset.defaultSrc = image.getAttribute('src') || '';
            image.dataset.defaultSrcset = image.getAttribute('srcset') || '';
          }
          this.setCardImage(image, image.dataset.defaultSrc, image.dataset.defaultSrcset);
        }
        let colors;
        try { colors = JSON.parse(card.querySelector('[data-finished-colors]').textContent); }
        catch (_) { return; }
        const matches = colors.filter(color => key && color.key === key);
        if (matches.length !== 1) return;
        const url = new URL(card.dataset.productUrl, window.location.origin);
        url.searchParams.set('selectcolor', matches[0].name);
        link.href = url.pathname + url.search;
        label.textContent = matches[0].name;
        label.hidden = false;
        // Show that color's first photo (its variant image); keep the product's first image otherwise.
        if (image && matches[0].image) this.setCardImage(image, matches[0].image, matches[0].srcset || '');
      });
    }
    setCardImage(image, src, srcset) {
      if (image.getAttribute('src') === src && (image.getAttribute('srcset') || '') === srcset) return;
      // Set srcset before src so the browser does not fetch the old candidate first.
      if (srcset) image.setAttribute('srcset', srcset);
      else image.removeAttribute('srcset');
      image.setAttribute('src', src);
    }
  });
}
